import React from 'react';
import { FadeIn } from './FadeIn';
import { Truck, Gift, RefreshCw, Zap } from 'lucide-react';
export function TodoLoQueRecibes() {
  const items = [{
    icon: <div className="w-8 h-8" data-id="element-925" />,
    label: 'Amazon FBA'
  }, {
    icon: <Truck className="w-8 h-8" data-id="element-926" />,
    label: 'Amazon FBM'
  }, {
    icon: <Gift className="w-8 h-8" data-id="element-927" />,
    label: 'Todos los Bonos Premium'
  }, {
    icon: <RefreshCw className="w-8 h-8" data-id="element-928" />,
    label: 'Actualizaciones futuras'
  }, {
    icon: <Zap className="w-8 h-8" data-id="element-929" />,
    label: 'Acceso inmediato'
  }];
  return <section className="bg-brand-green py-20 md:py-32 px-4 sm:px-6 relative overflow-hidden" data-id="element-930">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10 mix-blend-overlay" data-id="element-931"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-932">
        <FadeIn data-id="element-933">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-16 tracking-tight" data-id="element-934">
            Todo lo que recibes hoy
          </h2>
        </FadeIn>

        <div className="flex flex-wrap justify-center gap-6 sm:gap-8" data-id="element-935">
          {items.map((item, i) => <FadeIn key={i} delay={0.1 * i} data-id="element-936">
              <div className="flex items-center gap-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl px-6 py-5 hover:bg-white/15 transition-colors" data-id="element-937">
                <div className="text-brand-gold flex-shrink-0" data-id="element-938">{item.icon}</div>
                <span className="text-white font-medium text-lg" data-id="element-939">
                  {item.label}
                </span>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}